import { FAQS_FETCH_SUCCESS } from "../actions/types";

const INIT_STATE = {
  faqs: [],
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case FAQS_FETCH_SUCCESS: {
      return {
        ...state,
        faqs: action.payload,
      };
    }
    default:
      return state;
  }
};
